import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";

const ChooseSubscription = Loadable(
  lazy(() =>
    import("./chooseSubscription").then(({ ChooseSubscription }) => ({
      default: ChooseSubscription,
    }))
  )
);

const SubscriptionSetup = Loadable(
  lazy(() =>
    import("./SubscirptionSetup").then(({ SubscriptionSetup }) => ({
      default: SubscriptionSetup,
    }))
  )
);

export const ChooseSubscriptionRoutes = [
  {
    path: "/choose-subscription",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.SUBSCRIPTION]}>
        <ChooseSubscription />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/subscription-billing",
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleIds={[]}>
        <SubscriptionSetup />
      </AuthorizedRoute>
    ),
  },
];
